(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["icon-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eilleo-icon-list')) {
    customElements.define('eilleo-icon-list', class extends HTMLElement {
      connectedCallback() {
        if (this.moving) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.scroller = this.querySelector('.eilleo-icon-list__scroller');
        this.spec = this.querySelector('.eilleo-icon-list__spec');
        if (!this.scroller || !this.spec) return;
        this.addEventListener('click', (event) => event.stopPropagation(), options);
        this.desktop = window.matchMedia('(min-width: 1024px)');
        this.place = this.place.bind(this);
        this.updateScroll = this.updateScroll.bind(this);
        this.desktop.addEventListener('change', this.place, options);
        this.scroller.addEventListener('scroll', this.updateScroll, { ...options, passive: true });
        this.scroller.addEventListener('mouseenter', () => this.hoverScroll(true), options);
        this.scroller.addEventListener('mouseleave', () => this.hoverScroll(false), options);
        document.addEventListener('shopify:block:select', (event) => {
          if (event.target === this || this.contains(event.target)) this.updateScroll();
        }, options);
        this.frame = requestAnimationFrame(() => {
          this.place();
          this.observer = new ResizeObserver(this.updateScroll);
          this.observer.observe(this.scroller);
          if (this.home) {
            this.homeObserver = new MutationObserver(() => {
              if (!this.home?.isConnected) this.remove();
              else this.place();
            });
            this.homeObserver.observe(this.closest('.shopify-section'), {
              childList: true,
              subtree: true,
              attributes: true,
              attributeFilter: ['style', 'class']
            });
          }
          this.updateScroll();
        });
      }

      disconnectedCallback() {
        if (this.moving) return;
        this.controller?.abort();
        this.observer?.disconnect();
        this.homeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        this.home?.remove();
        this.home = null;
      }

      place() {
        if (this.dataset.belowMedia !== 'true') return;
        const section = this.closest('.shopify-section');
        const media = Array.from(section?.querySelectorAll('.product-information__media') || [])
          .find((element) => getComputedStyle(element).display !== 'none');
        if (!media) return;
        if (!this.home) {
          this.home = document.createElement('template');
          this.before(this.home);
        }
        if (this.desktop.matches && this.parentElement !== media.parentElement) {
          const column = getComputedStyle(media).gridColumn;
          this.style.setProperty('--eilleo-media-column', column === 'auto' ?
            (media.parentElement.classList.contains('product-information--media-right') ? '2' : '1') : column);
          this.moving = true;
          media.after(this);
          this.toggleAttribute('data-media-position', true);
          this.moving = false;
        } else if (!this.desktop.matches && this.home.parentElement && this.parentElement !== this.home.parentElement) {
          this.moving = true;
          this.home.after(this);
          this.toggleAttribute('data-media-position', false);
          this.moving = false;
        }
        this.updateScroll();
      }

      updateScroll() {
        const maximum = this.scroller.scrollWidth - this.scroller.clientWidth;
        const position = Math.abs(this.scroller.scrollLeft);
        const scrollable = maximum > 1;
        if (scrollable) this.scroller.setAttribute('tabindex', '0');
        else this.scroller.removeAttribute('tabindex');
        this.spec.toggleAttribute('data-scroll-start', scrollable && position > 1);
        this.spec.toggleAttribute('data-scroll-end', scrollable && position < maximum - 1);
      }

      hoverScroll(toEnd) {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this.scroller.scrollTo({
          left: toEnd ? this.scroller.scrollWidth * direction : 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trust-assurances"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eilleo-trust-assurances')) {
    const policyCache = new Map();
    customElements.define('eilleo-trust-assurances', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[data-policy-body]');
        this.ticket = 0;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-eilleo-policy]');
          if (link && typeof this.dialog.showModal === 'function') {
            const url = new URL(link.href, location.href);
            if (url.origin !== location.origin) return;
            event.preventDefault();
            event.stopPropagation();
            this.openPolicy(link, url);
          }
        }, options);
        this.querySelector('[data-policy-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          this.request?.abort();
          this.ticket++;
          this.trigger?.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        for (const type of ['wheel', 'touchmove']) {
          this.dialog.addEventListener(type, (event) => {
            if (event.target === this.dialog) event.preventDefault();
          }, { ...options, passive: false });
        }
      }

      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        if (this.dialog?.open) this.dialog.close();
      }

      async openPolicy(link, url) {
        this.request?.abort();
        this.trigger = link;
        const ticket = ++this.ticket;
        this.querySelector('[data-policy-title]').textContent = link.querySelector('.eilleo-trust__title').textContent;
        this.querySelector('[data-policy-link]').href = url.href;
        const message = document.createElement('p');
        message.textContent = this.content.dataset.loading;
        this.content.replaceChildren(message);
        this.content.setAttribute('aria-busy', 'true');
        if (!this.dialog.open) this.dialog.showModal();
        url.searchParams.set('view', 'eilleo-policy');
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        const theme = window.Shopify?.theme;
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        else if (theme?.id && theme.role !== 'main') url.searchParams.set('preview_theme_id', String(theme.id));
        let html = policyCache.get(url.href);
        const controller = new AbortController();
        this.request = controller;
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          if (!html) {
            const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
            if (!response.ok) throw new Error('Policy request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const policy = doc.querySelector('[data-eilleo-policy-content]');
            if (!policy || !policy.textContent.trim()) throw new Error('Policy content is missing');
            policy.querySelectorAll('script, style, link, iframe, object, embed').forEach((element) => element.remove());
            for (const element of policy.querySelectorAll('*')) {
              for (const attribute of Array.from(element.attributes)) {
                if (attribute.name.startsWith('on') || /^(javascript|data):/i.test(attribute.value.trim())) element.removeAttribute(attribute.name);
              }
            }
            policy.querySelectorAll('img').forEach((image) => { image.loading = 'lazy'; image.decoding = 'async'; });
            html = policy.innerHTML;
            policyCache.set(url.href, html);
          }
          if (ticket === this.ticket && this.dialog.open) this.content.innerHTML = html;
        } catch (error) {
          if (ticket === this.ticket && this.dialog.open) message.textContent = this.content.dataset.error;
        } finally {
          clearTimeout(timeout);
          if (ticket === this.ticket) this.content.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
